<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="产品code" prop="productCode">
          <el-input v-model="dataForm.productCode" placeholder="产品code"></el-input>
      </el-form-item>
          <el-form-item label="进件编号" prop="tenderId">
          <el-input v-model="dataForm.tenderId" placeholder="进件编号"></el-input>
      </el-form-item>
          <el-form-item label="放款总额" prop="totalLoans">
          <el-input v-model="dataForm.totalLoans" placeholder="放款总额"></el-input>
      </el-form-item>
          <el-form-item label="分润总额" prop="totalProfit">
          <el-input v-model="dataForm.totalProfit" placeholder="分润总额"></el-input>
      </el-form-item>
          <el-form-item label="提成" prop="commission">
          <el-input v-model="dataForm.commission" placeholder="提成"></el-input>
      </el-form-item>
          <el-form-item label="上级津贴" prop="seniorClassAllowance">
          <el-input v-model="dataForm.seniorClassAllowance" placeholder="上级津贴"></el-input>
      </el-form-item>
          <el-form-item label="上上级津贴" prop="superiorAllowance">
          <el-input v-model="dataForm.superiorAllowance" placeholder="上上级津贴"></el-input>
      </el-form-item>
          <el-form-item label="结算时间" prop="settlementTime">
          <el-input v-model="dataForm.settlementTime" placeholder="结算时间"></el-input>
      </el-form-item>
          <el-form-item label="提现状态" prop="status">
          <el-input v-model="dataForm.status" placeholder="提现状态"></el-input>
      </el-form-item>
          <!-- <el-form-item label="下一步提现状态" prop="nextStatus">
          <el-input v-model="dataForm.nextStatus" placeholder="下一步提现状态"></el-input>
      </el-form-item> -->
  
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        productCode: '',
        tenderId: '',
        totalLoans: '',
        totalProfit: '',
        commission: '',
        seniorClassAllowance: '',
        superiorAllowance: '',
        settlementTime: '',
        status: '',
        nextStatus: '',
        updateBy: '',
        updateTime: '',
        creator: '',
        createDate: '',
        deleteTime: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        productCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        tenderId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        totalLoans: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        totalProfit: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        commission: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        seniorClassAllowance: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        superiorAllowance: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        settlementTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        nextStatus: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deleteTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/slprofitmanagement/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/slprofitmanagement/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
